export default __webpack_public_path__ + "static/ai-marketing-6--mobile-04878d96dbe9f83febfc14d98a7b6bd0.png";